import { useState } from "react";

export const useModal = () => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState<any | null>(null);

  const toggleWithData = (data: any) => {
    setData(data);
    setOpen(!open);
  };
  const toggle = (open: boolean) => {
    setOpen(open);
    if (!open) {
      setData(null);
    }
  };

  return { open, data, toggleWithData, toggle };
};
